(function () {
  'use strict';

  function init() {
    document.querySelectorAll('[data-testid="howto"]').forEach(function (root) {
      // Sections can load this asset more than once; bind each facade only once.
      if (root.dataset.howtoReady) return;
      root.dataset.howtoReady = 'true';
      var button = root.querySelector('.howto-play');
      var dialog = root.querySelector('.howto-dialog');
      var stage = root.querySelector('.howto-stage');
      var video;

      button.addEventListener('click', function () {
        if (!video) {
          var profile = window.matchMedia('(max-width: 760px)').matches ? 'mobile' : 'desktop';
          video = root.querySelector('template[data-profile="' + profile + '"]')
            .content.querySelector('video').cloneNode(true);
          video.muted = true;
          stage.appendChild(video);
        }
        stage.hidden = false;
        if (dialog) {
          dialog.showModal();
        } else {
          button.hidden = true;
          video.focus();
        }
        var playing = video.play();
        if (playing && playing.catch) playing.catch(function () {});
      });

      if (dialog) {
        root.querySelector('[data-testid="howto-close"]').addEventListener('click', function () {
          dialog.close();
        });
        dialog.addEventListener('close', function () {
          if (video) video.pause();
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());
